import React from "react";

const Plus = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="50" height="50" className="plus">
    <defs>
      <filter id="a" width="50" height="50" x="0" y="0" filterUnits="userSpaceOnUse">
        <feOffset dy="3" />
        <feGaussianBlur result="blur" stdDeviation="3" />
        <feFlood floodOpacity=".161" />
        <feComposite in2="blur" operator="in" />
        <feComposite in="SourceGraphic" />
      </filter>
    </defs>
    <g data-name="Group 3787">
      <g filter="url(#a)">
        <circle cx="16" cy="16" r="16" data-name="Ellipse 86" transform="translate(9 6)" fill="#4585ff" />
      </g>
      <path
        d="M32.682 20.682h-6.364v-6.364A1.318 1.318 0 0025 13a1.318 1.318 0 00-1.318 1.318v6.364h-6.364A1.318 1.318 0 0016 22a1.318 1.318 0 001.318 1.318h6.364v6.364A1.318 1.318 0 0025 31a1.318 1.318 0 001.318-1.318v-6.364h6.364A1.318 1.318 0 0034 22a1.318 1.318 0 00-1.318-1.318z"
        data-name="Path 233"
        fill="#fff"
      />
    </g>
  </svg>
);

export default Plus;
